<dx-load-panel
  [shadingColor]="option.shadingColor"
  [visible]="option.visible"
  [showIndicator]="true"
  [showPane]="option.showPane"
  [shading]="true"
  [message]="option.message"
  [hideOnOutsideClick]="option.hideOnOutsideClick"
  [position]="{ of: option.ofPosition }"
>
</dx-load-panel>